// CLEARZORB CUSTOM CODE START
// common.js — Shopify-compatible version
//
// Explicitly set scrollRestoration = 'auto' so Safari (and all browsers) handle
// back/forward scroll position natively. The original HTML-prototype code set
// 'manual' here and then tried to restore via jQuery .load("header.html") —
// those files do not exist in Shopify, so the Promises never resolved, and
// Safari was permanently left at scroll = 0 on every back-navigation.
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'auto';
}

if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });
}
// CLEARZORB CUSTOM CODE END
